export const environment = {
	production: true,
	webappName: 'KVVM',
	appVersionAddon: '',
	google_api_key: 'AIzaSyAhCM17PVvPVXWMnGTOzdllFDOCTBJxrrQ',  // gitleaks:allow
	api_endpoint: 'https://app.kvvm.nl/api/v1/',
	sentry: 'https://7805fea1cf0df9c55f7f20412a168c3e@o4507735602298880.ingest.de.sentry.io/4508284253241424'
};
